<template>
    <v-row>
        <div v-if="showDialog" fullscreen scrollable persistent no-click-animation 
           style="z-index:20002; position: fixed; top: 0px; bottom: 0px; left: 0px; right: 0px; overflow: hidden;"
          >
            <v-card style="height: 100%">
                <v-card-text @wheel="onWheel" class="pa-0">
                    <v-container fluid>
                        <v-row style="background-color: #185EA9;" class="fixNotchPaddingTop">
                            <v-col cols="12" class="pa-4 d-flex align-center">
                                <v-btn icon @click="close()">
                                    <v-icon color="white">arrow_back</v-icon>
                                </v-btn>
                                <span class="text-truncate white--text" style="font-size: 1.5em">
                                    {{ data.name ? data.name : '' }}
                                </span>
                            </v-col>
                        </v-row>

                        <v-skeleton-loader v-if="isLoading" type="table-tbody" class="my-4" min-height="100%" />

                        <v-row v-if="!isLoading">
                            <v-col cols="12">
                                <!-- VISTA DESKTOP -->
                                <div v-if="!$vuetify.breakpoint.mobile">
                                    <ExpenseSheetDesktopHeader 
                                    :data="data" 
                                    :employeeId="employeeId" 
                                    :hasItems="items.length > 0"
                                    @edit-expense-sheet="editExpenseSheet()"
                                    @confirm-send-expense-sheet="confirmSendExpenseSheet()"
                                    @cancel-expense-sheet-request="cancelExpenseSheetRequest()" />
                                </div>

                                <!-- VISTA MOBILE -->
                                <div v-if="$vuetify.breakpoint.mobile">
                                    <ExpenseSheetMobileHeader 
                                    :data="data" 
                                    :employeeId="employeeId" 
                                    :hasItems="items.length > 0"
                                    @edit-expense-sheet="editExpenseSheet()"
                                    @confirm-send-expense-sheet="confirmSendExpenseSheet()"
                                    @cancel-expense-sheet-request="cancelExpenseSheetRequest()" />
                                </div>
                            </v-col>
                        </v-row>

                        <v-row v-if="!isLoading && items.length === 0" class="mt-6">
                            <v-col cols="12" class="pt-1 d-flex align-center justify-center flex-column">
                                <div style="border-radius: 100%; width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12);">
                                    <v-icon x-large style="color: grey; font-size: 4em;">layers_clear</v-icon> 
                                </div>                                            
                                <span class="mt-2" style="font-size: 16px; color: grey;">{{ $t('wkt.client.expensesheets.detail-window.no_data') }}</span>
                            </v-col>
                        </v-row>

                        <!-- VISTA DESKTOP -->
                        <div v-if="!isLoading && items.length > 0 && !$vuetify.breakpoint.mobile">
                            <ExpenseSheetItemsTable
                            :parent="data"
                            :items="items" 
                            @download-document="downloadDocument($event)"
                            @edit-item="editExpenseSheetItem($event)"
                            @view-item="viewExpenseSheetItem($event)" />
                        </div>

                        <!-- VISTA MOBILE -->
                        <div v-if="!isLoading && items.length > 0 && $vuetify.breakpoint.mobile">
                            <ExpenseSheetItemCardList 
                            :parent="data"
                            :items="items" 
                            @download-document="downloadDocument($event)"
                            @edit-item="editExpenseSheetItem($event)"
                            @view-item="viewExpenseSheetItem($event)" />
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>

            <v-tooltip v-if="!isLoading && [-1,2].includes(data.status)" left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                    dark fixed 
                    bottom
                    right 
                    fab 
                    color="#185EA9" 
                    v-bind="attrs" 
                    v-on="on" 
                    @click="addExpenseSheetItem()">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('wkt.client.expensesheets.detail-window.add_expense_sheet_item') }}</span>
            </v-tooltip>
        </div>
  
        <ExpenseSheetDialog ref="dlgEdit" @show-alert="$emit('show-alert', $event)" />
        <ExpenseSheetItemDialog ref="dlgEditItem" @show-alert="$emit('show-alert', $event)" />
  
        <!--<ConfirmDialog ref="dlgConfirmDelete"
            v-bind:title="$t('wkt.client.expensesheets.confirm-delete-dialog.title')"
            v-bind:message="$t('wkt.client.expensesheets.confirm-delete-dialog.text')"
            v-bind:titleOk="$t('wkt.client.common.dialog-buttons.delete')"
            v-bind:titleCancel="$t('wkt.client.common.dialog-buttons.cancel')"
            v-on:confirmed="deleteParentItem()"
        />-->
  
        <ConfirmDialog ref="dlgConfirmSend"
            v-bind:title="$t('wkt.client.expensesheets.confirm-send-dialog.title')"
            v-bind:message="$t('wkt.client.expensesheets.confirm-send-dialog.text')"
            v-bind:titleOk="$t('wkt.client.common.dialog-buttons.send')"
            v-bind:titleCancel="$t('wkt.client.common.dialog-buttons.cancel')"
            v-on:confirmed="sendExpenseSheet()"
        />

    </v-row>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'
import ExpenseSheetDesktopHeader from './ExpenseSheetDesktopHeader'
import ExpenseSheetMobileHeader from './ExpenseSheetMobileHeader'
import ExpenseSheetItemsTable from './ExpenseSheetItemsTable'
import ExpenseSheetItemCardList from './ExpenseSheetItemCardList'
import ExpenseSheetDialog from './ExpenseSheetDialog'
import ExpenseSheetItemDialog from './ExpenseSheetItemDialog'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'

export default {
    name: 'ExpenseSheetDetailDialog',
    mixins: [BaseModule],
    components: {
        ExpenseSheetDesktopHeader, 
        ExpenseSheetMobileHeader, 
        ConfirmDialog, 
        ExpenseSheetItemsTable, 
        ExpenseSheetItemCardList, 
        ExpenseSheetDialog, 
        ExpenseSheetItemDialog
    },  
    data() {
        return { 
            showDialog: false,
            isLoading: false,
			//msgCb: null,
            employeeId: null,
            data: {},
			//search: "",
			options: { itemsPerPage: 20 },
			items: [],
        }
    },
    methods: {
        onWheel(event) {
            event.stopPropagation();
        },
        onReveal(id) {
            this.open(id);
        },
        open(id) {
			this.employeeId = gwt.getSessionInformation().employee.id;

            this.showDialog = true;
            this.getFullExpenseSheetById(id);
        },
        close() {
            this.showDialog = false;
        },
		getFullExpenseSheetById(id) {
			this.isLoading = true;

			api.getFullExpenseSheetById(id,
                data => {
                    this.isLoading = false;
                    this.data = data;
                    this.getExpenseSheetItemsBySheetId(); 
                }, 
                err => {
                    this.isLoading = false;
                    console.log(err);
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
                }
            );
		},
		getExpenseSheetItemsBySheetId() {
			this.isLoading = true;

			// eslint-disable-next-line no-unused-vars
			const { sortBy, sortDesc, page, itemsPerPage } = this.options;

			api.getExpenseSheetItemsBySheetId(this.data.id, 'id', true,
			//api.getExpenseSheetItemsBySheetId(this.data.id, sortBy ? sortBy : '', sortDesc,
                data => {
                    this.isLoading = false;
                    this.items = data;
                }, 
                err => {
                    this.isLoading = false;
                    console.log(err);
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
                }
            );
		},
        editExpenseSheet() {
            this.$refs.dlgEdit.open(this.data.id, 
                () => {
                    this.getFullExpenseSheetById(this.data.id);
                    this.$emit('refresh');
                },
                () => {
                    this.close();
                    this.$emit('refresh');
                }
            );
        },
        confirmSendExpenseSheet() {
            this.$refs.dlgConfirmSend.confirm(this.data);
        },
        sendExpenseSheet() {
            this.isLoading = true;

            api.sendExpenseSheetById(this.data.id, 
                res => {
                    this.showDialog = false;
                    this.isLoading = false;
                    this.$emit('refresh');
					if (res) {
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.send_ok'), color: 'success', timeout: 3000 });
					} else {
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.send_error'), color: 'error', timeout: 3000 });
					}
                },
                err => {
                    this.isLoading = false;
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
                }
            );
        },
        cancelExpenseSheetRequest() {
            this.isLoading = true;

            api.cancelExpenseSheetRequestById(this.data.id, 
                res => {
                    this.isLoading = false;
                    if (res) {
                        this.getFullExpenseSheetById(this.data.id);
                        this.$emit('refresh');
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.cancel_request_ok'), color: 'success', timeout: 3000 });
					} else {
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.cancel_request_error'), color: 'error', timeout: 3000 });
					}
                },
                err => {
                    this.isLoading = false;
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
                }
            );
        },
        addExpenseSheetItem() {
            this.$refs.dlgEditItem.open(null, this.data.id, true, 
                () => {
                    this.getFullExpenseSheetById(this.data.id);
                    this.getExpenseSheetItemsBySheetId();
                    this.$emit('refresh');
                },
                () => {
                    this.getFullExpenseSheetById(this.data.id);
                    this.getExpenseSheetItemsBySheetId();
                    this.$emit('refresh');
                }
            );
        },
		editExpenseSheetItem(item) {            
            this.$refs.dlgEditItem.open(item.id, this.data.id, true, 
                () => {
                    this.getFullExpenseSheetById(this.data.id);
                    this.getExpenseSheetItemsBySheetId();
                    this.$emit('refresh');
                },
                () => {
                    this.getFullExpenseSheetById(this.data.id);
                    this.getExpenseSheetItemsBySheetId();
                    this.$emit('refresh');
                }
            );
        }, 
		viewExpenseSheetItem(item) {            
            this.$refs.dlgEditItem.open(item.id, this.data.id, false);
        },        
		downloadExpenseSheetItemDocumentContent(item) {
			this.isLoading = true;

			this.downloadExpenseSheetItemDocumentContentAsBase64(this.data.id, item.id,
                data => {
                    this.isLoading = false;
                    const win = window.open();
                    win.document.write(`<iframe src="${data}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`);
                }, 
                err => {
                    this.isLoading = false;
                    console.log(err);
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
                }
            );
		},
		downloadDocument(item) {
			gwt.downloadFile(`user/expense-sheet-item/${this.data.id}/download/${item.id}`, item.documentName);
		},
    }
};
</script>
